import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, Clock, CreditCard } from 'lucide-react';
import StaffPage from './StaffPage';
import TimeTrackingPage from './TimeTrackingPage';

// Zentraler Personal-Bereich: Mitarbeiter, Stunden und Lohn an einem Ort.
const PersonalPage = ({ embedded = false, defaultTab = null }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  let isAdmin = false;
  try {
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      isAdmin = payload.role === 'admin';
    }
  } catch (_) {
    isAdmin = false;
  }

  const allowed = isAdmin ? ['mitarbeiter', 'stunden', 'lohn'] : ['stunden'];
  const requested = searchParams.get('tab') || defaultTab;
  const active = allowed.includes(requested) ? requested : allowed[0];

  const handleChange = (value) => {
    setSearchParams(value === 'mitarbeiter' ? {} : { tab: value }, { replace: true });
  };

  return (
    <div className="p-6 space-y-6" data-testid="personal-hub-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2">
          <Users size={28} />
          Personal
        </h1>
        <p className="text-gray-600 mt-1 text-sm sm:text-base">
          Mitarbeiter, Stunden und Lohn an einem Ort
        </p>
      </div>

      <Tabs value={active} onValueChange={handleChange}>
        <TabsList className={`grid w-full ${isAdmin ? 'grid-cols-3 lg:w-[480px]' : 'grid-cols-1 lg:w-[200px]'}`}>
          {isAdmin && (
            <TabsTrigger value="mitarbeiter" data-testid="personal-tab-mitarbeiter" className="flex items-center gap-2">
              <Users size={16} />
              Mitarbeiter
            </TabsTrigger>
          )}
          <TabsTrigger value="stunden" data-testid="personal-tab-stunden" className="flex items-center gap-2">
            <Clock size={16} />
            Stunden
          </TabsTrigger>
          {isAdmin && (
            <TabsTrigger value="lohn" data-testid="personal-tab-lohn" className="flex items-center gap-2">
              <CreditCard size={16} />
              Lohn
            </TabsTrigger>
          )}
        </TabsList>
      </Tabs>

      <div className="mt-4">
        {active === 'mitarbeiter' && isAdmin && <StaffPage embedded />}
        {(active === 'stunden' || active === 'lohn') && (
          <TimeTrackingPage embedded mode={active === 'lohn' ? 'payroll' : 'hours'} />
        )}
      </div>
    </div>
  );
};

export default PersonalPage;
